import { coachingApplicationService } from "@/api/services/coaching-application.service";
import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { insertCoachingApplicationSchema } from "@thecoach/db";
import { z } from "zod";
import { authMiddlewareServer } from "../middleware/auth";

export const createCoachingApplicationFn = createServerFn({ method: "POST" })
  .inputValidator(insertCoachingApplicationSchema)
  .handler(async ({ data }) => {
    if (data.website) return { status: 201, body: { accepted: true } };

    const { website: _website, ...applicationData } = data;
    const application =
      await coachingApplicationService.create(applicationData);
    return {
      status: 201,
      body: { accepted: true, applicationId: application.applicationId },
    };
  });

export const listCoachingApplicationsFn = createServerFn({ method: "GET" })
  .middleware([authMiddlewareServer])
  .handler(async ({ context }) => {
    if (context.auth.role !== "admin") throw new Error("Unauthorized");
    return { status: 200, body: await coachingApplicationService.list() };
  });

const applicationStatusSchema = z.object({
  applicationId: z.string().min(1),
  status: z.enum(["new", "contacted", "qualified", "closed"]),
});

export const updateCoachingApplicationStatusFn = createServerFn({
  method: "POST",
})
  .middleware([authMiddlewareServer])
  .inputValidator(applicationStatusSchema)
  .handler(async ({ context, data }) => {
    if (context.auth.role !== "admin") throw new Error("Unauthorized");
    const application = await coachingApplicationService.updateStatus(
      data.applicationId,
      data.status,
    );
    if (!application) throw new Error("Başvuru bulunamadı");
    return { status: 200, body: application };
  });

export const listCoachingApplicationsOptions = () =>
  queryOptions({
    queryKey: ["admin", "coaching-applications"],
    queryFn: () => listCoachingApplicationsFn(),
  });
